import { LN_DATA } from "../constants";
import lnScript from "./ln-loader";

declare let tm: any;
//Métodos para generar un sessionId único para cada usuario

const sha256 = (hexstr: string) => {
  // We transform the string into an arraybuffer.
  const buffer = new Uint8Array(
    hexstr.match(/[\da-f]{2}/gi)!.map((h) => {
      return parseInt(h, 16);
    })
  );
  return crypto.subtle.digest("SHA-256", buffer).then((hash) => {
    return arbuf2hex(hash);
  });
};

const arbuf2hex = (buffer: any) => {
  let hexCodes = [];
  const view = new DataView(buffer);
  for (let i = 0; i < view.byteLength; i += 4) {
    // Using getUint32 reduces the number of iterations needed (we process 4 bytes each time)
    let value = view.getUint32(i);
    // toString(16) will give the hex representation of the number without padding
    let stringValue = value.toString(16);
    // We use concatenation and slice for padding
    let padding = "00000000";
    let paddedValue = (padding + stringValue).slice(-padding.length);
    hexCodes.push(paddedValue);
  }

  // Join all the hex strings into one
  return hexCodes.join("");
};

export const loadScript = (): Promise<void> =>
  new Promise((resolve, reject) => {
    console.log("Loading lnScript");
    if (document.getElementById("lnScript")) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.text = lnScript;
    script.id = "lnScript";
    script.async = true;

    script.onerror = () => reject(new Error("Failed to load script: lnScript"));

    document.body.appendChild(script);
    resolve();
  });

export const generateSessionId = async (orderId: string) => {
  const todayDate = new Date();
  const sessionIden = orderId + todayDate.toISOString();
  const sessionId = await sha256(sessionIden);

  const noScript = document.createElement("noscript");
  noScript.innerHTML = `<iframe style="width: 100px; height: 100px; border: 0; position: absolute; top: -5000px;" src="https://${LN_DATA.LN_DOMAIN}/fp/tags?org_id=${LN_DATA.LN_ORG_ID}&session_id=${sessionId}"></iframe>`;
  document.body.appendChild(noScript);

  await loadScript();
  console.log(
    "Initializing ThreatMetrix with sessionId:",
    LN_DATA.LN_DOMAIN,
    LN_DATA.LN_ORG_ID,
    sessionId
  );
  tm.profile(LN_DATA.LN_DOMAIN, LN_DATA.LN_ORG_ID, sessionId);
  return sessionId;
};
